import { gql } from "@apollo/client";






export const UPDATE_GRATUITY = gql`
  mutation updateGratuity($input: updateGratuityInput) {
    updateGratuity(input: $input)
  }
`;



export const UPDATE_SETTLEMENT = gql`
  mutation UpdateSettlement($input: updateSettlementInput) {
    updateSettlement(input: $input) {
      employeeName
    }
  }
`;


